import { useSelector } from 'react-redux';

import { useSite } from '@labradorsports/utils';

import { Selectors, useGetInvitePreviewQuery } from '../../../store/index.js';
import { InlineLoadingSpinner } from '../../index.js';

interface Props {
    team: any;
    person?: any;
    inviteType: string;
}

const InvitePreview: FC<Props> = ({ team, person, inviteType }) => {
    const { data: invitePreview, isFetching } = useGetInvitePreviewQuery({
        type: inviteType,
        entityId: team.id,
        email: person?.email,
    });
    const basicDetails = useSelector(Selectors.basicDetails);
    const { Config } = useSite();

    if (!team) return null;

    if (isFetching) {
        return <InlineLoadingSpinner />;
    }

    return (
        <div className="invite-preview">
            <h1 className="mt-4">Email Preview</h1>
            {person ? (
                <div>
                    <em>To: </em>
                    {person.email}
                </div>
            ) : null}
            <div>
                <em>From: </em>Coach {basicDetails.firstName} via {Config.SiteConfig.SiteName}
            </div>
            <div>
                <em>Subject: </em>You&apos;re Invited to {Config.SiteConfig.SiteName}
            </div>
            <div className="invite-email-wrapper">
                <div className="invite-email">
                    <div dangerouslySetInnerHTML={{ __html: invitePreview }} />
                </div>
            </div>
        </div>
    );
};

export default InvitePreview;
